import React, { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";

type Props = {
  route: string;
  name: string;
  iconDeactivate: string;
  iconActive: string;
};

const NavItem: React.FC<Props> = ({
  route,
  name,
  iconDeactivate,
  iconActive,
}): JSX.Element => {
  const location = useLocation();

  const activeRoute = (route: string) => {
    return location.pathname.includes(`/${route}`) ? true : false;
  };

  return (
    <Fragment>
      {activeRoute(route) ? (
        <Link
          to={`/${route}`}
          className={`flex flex-row bg-gray-300 h-16 mb-4 w-full z-30`}
          style={{
            width: "300px",
            border: "1px solid #D6D6D6",
            background: "#F5F5F5",
            borderRadius: "5px",
          }}
        >
          <div className="flex flex-col my-auto ml-6">
            <img src={iconActive} alt="building" width={24} height={24} />
          </div>

          <div
            className="ml-5 flex flex-col my-auto font-sora text-base"
            style={{
              color: "#408E5A",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            {name}
          </div>
        </Link>
      ) : (
        <Link to={`/${route}`} className={`flex flex-row h-16 mb-4`}>
          <div className="flex flex-col my-auto ml-6">
            <img src={iconDeactivate} alt="building" width={24} height={24} />
          </div>
          <div
            className="ml-5 flex flex-col my-auto font-sora text-base"
            style={{
              color: "#8E8E8E",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            {name}
          </div>
        </Link>
      )}
    </Fragment>
  );
};

export default NavItem;
